import { type ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

export interface FormFieldProps {
  label: ReactNode;
  children: ReactNode;
  helperText?: ReactNode;
  error?: ReactNode;
  trailing?: ReactNode;
  className?: string;
}

export function FormField({
  label,
  children,
  helperText,
  error,
  trailing,
  className,
}: FormFieldProps): ReactNode {
  return (
    <label className={cn('block space-y-1.5', className)}>
      <span className="flex items-center justify-between gap-3">
        <span className="block text-xs font-semibold uppercase tracking-wider text-[var(--text-muted)]">
          {label}
        </span>
        {trailing}
      </span>
      {children}
      {error ? (
        <span className="block text-sm font-medium text-[var(--danger-text)]">
          {error}
        </span>
      ) : helperText ? (
        <span className="block text-sm text-[var(--text-secondary)]">{helperText}</span>
      ) : null}
    </label>
  );
}
